import { provideChameleonDesignSystem } from '../provideChameleonDesignSystem';
import { chameleonTopBar } from './TopBar.definition';
export function registerCustom(prefix, node) {
    return provideChameleonDesignSystem({ prefix, node }).register(chameleonTopBar({ prefix }));
}
